<template>
<div class="account-list">
  <div class="account-top">
    <h4 class="module-title">{{$t('User.myAcc')}}</h4>
    <div class="top-right">
      <el-tooltip
        class="item"
        effect="dark"
        placement="top"
      >
        <div slot="content">
          {{$t('You_can_also_add')}} {{canOpenAccountCount}} {{$t('Trading_accounts')}}
        </div>
        <el-button
          size="small"
          :disabled="canOpenAccountCount == 0"
          type="primary"
          @click="openAccountHandle"
          icon="el-icon-plus"
        >
          {{$t('add_account')}}
        </el-button>
      </el-tooltip>

      <div
        class="icon-btn-box"
        :class="{on: listType == 'list'}"
        @click="iconfontHandle('list')"
        :style="listIconStyleOpacty"
      >
        <i
          class="el-icon-s-unfold icon-btn"
        ></i>
      </div>
      <div
        class="icon-btn-box"
        :class="{on: listType == 'card'}"
        @click="iconfontHandle('card')"
        :style="cardIconStyleOpacty"
      >
        <i
          class="el-icon-menu icon-btn"
        ></i>
      </div>
    </div>
  </div>
  <el-row
    :gutter="10"
    v-loading="loading"
  >
      <el-col
        v-for="(item,index) in accountList"
        :key="index"
        :lg="lgComputed"
        :md="mdComputed"
        :sm="smComputed"
        :xs="24"
        :class="{'card-el-col': listType == 'card' }"
      >
        <account-card
          v-if="listType == 'card'"
          :is-demo="getIsDemo(item)"
          :account-info="item"
          @trande-click="trandeHandle"
          @lever-setting="leverSettingHandle"
          @password-setting="passwordSettingHandle"
          @type-set="typeSetHandle"
        ></account-card>
        <account-bar
          v-if="listType == 'list'"
          :is-demo="getIsDemo(item)"
          :account-info="item"
          @trande-click="trandeHandle"
          @lever-setting="leverSettingHandle"
          @password-setting="passwordSettingHandle"
          @type-set="typeSetHandle"
        ></account-bar>
      </el-col>
      <el-col
        v-if="accountList !== null && !accountList.length"
      >
        <p class="center no-data">{{$t('root.noData')}}</p>
      </el-col>
  </el-row>
  <account-type-set
      ref="typeset"
      :account-mt-id="currentAccountInfo.id"
      :dialog-show="accountTypeSetDialogShow"
      @close="accountTypeSetDialogShow = false"
      @ajax-success="typeSetSuccess"
  ></account-type-set>
  <down-mt4-dialog
    ref="downdialog"
    :account-info="currentAccountInfo"
  ></down-mt4-dialog>

  <leverage-setting
    ref="leverdialog"
    :cur-login="curLogin"
    :dialogShow="leverDialogShow"
    @close="leverDialogCloseHandel"
    @ajax-success="leverSettingSuccessHandle"
  ></leverage-setting>
  <mt4-password-setting
    ref="passworddialog"
    :dialogShow="setPasswordDialogShow"
    @close="passwordDialogCloseHandel"
    :cur-login="curLogin"
    @ajax-success="passwordSettingSuccessHandle"
  ></mt4-password-setting>
</div>
</template>

<script>
import accountTypeSet from "@/components/dashboard/accountTypeSet";
import { colorRgba } from '@/utils/index.js';
import { mapGetters } from 'vuex';

import mt4PasswordSetting from "@/components/public/mt4PasswordSetting";
import leverageSetting from "@/components/public/leverageSetting";
import downMt4Dialog from "@/components/public/downMt4Dialog";
import accountBar from "@/components/dashboard/accountBar";
import accountCard from "@/components/dashboard/accountCard";
import {mtAccList, queryAccountLimit} from "@/api/userCenter";
export default {
  name: "accountList",
  components: {
    accountCard,
    accountBar,
    downMt4Dialog,
    leverageSetting,
    mt4PasswordSetting,
    accountTypeSet,
  },
  props: {
    /*accountList: {
      type: Array,
      default(){
        return [];
      }
    },*/
    /*canOpenAccountCount: {
    },*/
  },

  data() {
    return {
      // listType: 'list',
      canOpenAccountCount: 0,
      accountList: null,
      listType: 'card',
      currentAccountInfo:{id: ''},
      leverDialogShow: false,
      curLogin: 0, // 杠杆和密码设置,
      setPasswordDialogShow: false,
      loading: false, // todo 需要调整

      accountTypeSetDialogShow: false,
    }
  },
  computed: {
    ...mapGetters(['listRefresh','themeColor','openAccountDialogShow','userInfo']),
    lgComputed(){
      if(this.listType == 'card'){
        return 6;
      }else {
        return 24;
      }
    },
    mdComputed(){
      if(this.listType == 'card'){
        return 12;
      }else {
        return 24;
      }
    },
    smComputed(){
      if(this.listType == 'card'){
        return 12;
      }else {
        return 24;
      }
    },
    listIconStyleOpacty(){
      if(this.listType == 'list'){
        return {
          background: colorRgba(this.themeColor,0.1),
        }
      }
    },
    cardIconStyleOpacty(){
      if(this.listType == 'card'){
        return {
          background: colorRgba(this.themeColor,0.1),
        }
      }
    },
  },
  watch: {
    listRefresh(){
      this.getCustMtaccount();
    }
  },
  created(){
    this.getCustMtaccount();
    if(this.openAccountDialogShow){
      this.openMt4DialogShow = true;
    }
    if(this.userInfo.id){
      this.queryAccountCount();
    }
  },
  beforeDestroy(){
    this.$store.commit('setOpenAccountDialogShow', false);
  },
  methods: {
    queryAccountCount(){
      // 开户前查询一下 todo
      queryAccountLimit({
        custId: this.userInfo.id,
      }).then((res) => {

        this.canOpenAccountCount = res.data.limit;
      })
    },
    getCustMtaccount(){
      //根据获取不同的帐号列表
      let mtAccListData = {
        id : this.userInfo.id,
        businessTypes: '0,1,3,5,6',//social也要加上
      }
      mtAccList(mtAccListData).then((res) => {
        this.accountList = res.data;
      }).catch((error) => {
        console.log(error);
      })
    },
    // 杠杆设置成功,刷新下账号列表,
    refreshList(){
      this.getCustMtaccount();
    },
    typeSetSuccess(){
      this.accountTypeSetDialogShow = false;
      // this.$emit('refresh-list');
      this.refreshList();
    },
    getIsDemo(item){
      return item.businessType == 5
    },
    iconfontHandle(listType) {
      this.listType = listType;
    },
    // 开户
    openAccountHandle(){
      this.$emit('open-account');
      if(this.canOpenAccountCount === 0) return;
      this.$store.commit('setOpenAccountDialogShow', true);
    },
    trandeHandle(accountInfo){
      this.currentAccountInfo = accountInfo;
      this.$refs.downdialog.dialogShow = true;
    },
    infoHandle(accountInfo){
      this.currentAccountInfo = accountInfo;
      this.$refs.infodialog.dialogShow = true;
    },
    leverSettingHandle(accountInfo){
      this.curLogin = accountInfo.login;
      this.leverDialogShow = true;
      this.$refs.leverdialog.$refs.form && this.$refs.leverdialog.$refs.form.clearValidate();
    },
    // 杠杆设置弹框关闭
    leverDialogCloseHandel(){
      this.curLogin = 0;
      this.leverDialogShow = false;
    },
    // 设置杠杆成功
    leverSettingSuccessHandle(){
      this.leverDialogShow = false;
      // this.$emit('refresh-list');
      this.refreshList();
    },
    // 设置密码 start
    passwordSettingHandle(accountInfo){
      this.curLogin = accountInfo.login;
      this.setPasswordDialogShow = true;
    },
    passwordDialogCloseHandel(){
      this.curLogin = 0;
      this.setPasswordDialogShow = false;
    },
    // 设置密码成功
    passwordSettingSuccessHandle(){
      this.setPasswordDialogShow = false;
      this.$message({
        message: this.$t('User.passSetSuccess'),
        type: 'success'
      });
    },
    // 账户类型设置
    typeSetHandle(accountInfo){
      this.currentAccountInfo = accountInfo;
      this.accountTypeSetDialogShow = true;
    },
  },
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variable";
.account-list {
  margin-top: 30px;
  .btn-icon {
    font-size: 16px;
    padding-right: 10px;
  }

  .account-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    .top-right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
    .icon-btn-box {
      cursor: pointer;
      width: 32px;
      height: 32px;
      border: 1px solid #D8D6DE;
      border-radius: 5px;
      margin: 0 0 0 10px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      &.on {
        border-color: $themeColor;
        .icon-btn {
          color: $themeColor;
        }
      }
    }
  }
  .no-data {
    line-height: 60px;
  }
  .module-title {
    font-size: 16px;
    color: #5E5873;
    font-weight: 600;
  }
  .neededit-btn {
    width: 100%;
    font-size: 12px;
    &:hover {
      border-color: #DCDFE6;
      color: #606266;
      background-color: #ffffff;
    }
  }

}
@media (min-width: 1200px) and (max-width: 1440px) {
  .card-el-col {
    width: 50%;
  }
}

</style>
<style lang="scss">
@import "../../assets/scss/variable";
.account-list {
  .login-num {
    font-size: 16px;
    font-weight: 600;
  }
  .tag {
    padding: 3px 6px;
    margin-left: 10px;
    border-radius: 17px;
    font-size: 12px;
    &.real-tag {
      color: $themeColor;
    }
    &.mt4-tag {
      background-color: rgba(186, 191, 199, 0.12);
    }
  }
  .neededit-btn {
    font-size: 12px;
    padding-left: 6px;
    padding-right: 6px;
  }
}
</style>
